import { Link } from "react-router-dom";
import { useT } from "@/lib/t";

export default function NotFound() {
  const t = useT();
  return (
    <div className="bg-ccc-paper min-h-[60vh] flex items-center" data-testid="not-found-page">
      <div className="max-w-3xl mx-auto px-6 py-24 text-left">
        <div className="text-xs uppercase tracking-[0.2em] text-ccc-gold mb-4">{t("nf.eyebrow")}</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ccc-plum leading-tight mb-6">
          {t("nf.title")}
        </h1>
        <p className="text-base text-stone-600 max-w-xl mb-10">{t("nf.body")}</p>
        <div className="flex flex-wrap gap-4">
          <Link to="/" data-testid="not-found-home-link"
                className="bg-ccc-plum text-white px-6 py-3 text-sm uppercase tracking-wider hover:bg-ccc-purple transition-colors">
            {t("nf.home")}
          </Link>
          <Link to="/legislative-work" data-testid="not-found-bills-link"
                className="border border-ccc-plum text-ccc-plum px-6 py-3 text-sm uppercase tracking-wider hover:bg-ccc-plum hover:text-white transition-colors">
            {t("nf.bills")}
          </Link>
        </div>
      </div>
    </div>
  );
}
